import onlineTheme from '../themes/online';

const iconsName = {
  paymentIcon: 'dollar',
  returnIcon: 'returnImage',
  successBoldIcon: 'successBold',
  applyOnlineLandingPageLayout: 'applyOnlineLandingPageLayout',
  partnersPortalLandingPageLayout: 'partnersPortalLandingPageLayout',
};

export const getFullIconsName = {
  email: onlineTheme.icons.email,
  phone: onlineTheme.icons.phone,
  dollar: onlineTheme.icons.dollar,
  person: onlineTheme.icons.personIcon,
  lock: onlineTheme.icons.lockIcon,
  completed: onlineTheme.icons.completed,
  dollarBlue: onlineTheme.icons.dollarBlue,
  returnImage: onlineTheme.icons.returnImage,
  successBold: onlineTheme.icons.successBold,
  returnImageBlue: onlineTheme.icons.returnImageBlue,
  successBoldBlue: onlineTheme.icons.successBoldBlue,
  partnersPortalLandingPageLayout: {
    leftUpperImage: onlineTheme.icons.blueTriangle,
    // leftBottomImage: onlineTheme.icons.womanWithIpad,
    // rightUpperImage: onlineTheme.icons.businessPeopleWithIpad,
    rightBottomImage: onlineTheme.icons.orangeTriangleLine,
  },
};

export default iconsName;
